import { useTranslation } from 'react-i18next';
import { Link, useLocation, generatePath } from 'react-router-dom';
import getSlug from 'speakingurl';

// Import styles
import { ButtonWrapper } from './styles';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import hooks
import { useAppSelector } from 'store/hooks';

// Import routes
import { VOD_PATHS } from 'components/routes/vod_routes/paths';

type Props = {
	sectionId: string;
	sectionTitle: string;
	redirectPath?: string;
};

const { SECTION_DETAILS } = VOD_PATHS;

export const VodSectionButton = ({ sectionId, sectionTitle, redirectPath = '' }: Props) => {
	const { t } = useTranslation();

	const { sectionsName } = useAppSelector(({ sections }) => sections);
	const { pathname } = useLocation();
	const sectionName = getSlug(sectionTitle);

	const redirectToSection = {
		pathname: generatePath(SECTION_DETAILS, { sectionId, sectionName }),
		state: {
			fromPage: sectionsName,
			fromPagePath: pathname
		}
	};

	const redirectTo = redirectPath || redirectToSection;

	return (
		<ButtonWrapper>
			<Button as={Link} to={redirectTo} variant="secondary" modifiers={['small', 'outlined']}>
				{t('vod_buttons_all_products')}
			</Button>
		</ButtonWrapper>
	);
};
